/* SUPERMOTO GANG — comportements globaux : reveal au scroll + carrousels d'avis. */
(function(){
  /* reveal au scroll */
  const reveals=document.querySelectorAll('.reveal');
  if(reveals.length){
    const io=new IntersectionObserver((es)=>{es.forEach((e)=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
    reveals.forEach(el=>io.observe(el));
  }

  /* carrousels d'avis : flèches ← → (data-rev-prev / data-rev-next ciblant le .rev-track parent) */
  function trackOf(btn){ const sec=btn.closest('section, .band, .wrap'); return sec ? sec.querySelector('.rev-track') : null; }
  function step(track,dir){ if(!track)return; const c=track.querySelector('.rev'); if(!c)return; const w=c.getBoundingClientRect().width+16; track.scrollLeft+=dir*w; }
  document.querySelectorAll('[data-rev-prev]').forEach(b=>b.addEventListener('click',()=>step(trackOf(b),-1)));
  document.querySelectorAll('[data-rev-next]').forEach(b=>b.addEventListener('click',()=>step(trackOf(b),1)));
})();
